module.exports = __webpack_public_path__ + "img/risks-liver-disease.dd8fa467.svg";